import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('SCHEDULE_TYPES');
